class Event {
    constructor(age,name,text,effect)
    {
        this.age = age;
        this.name = name;
        this.text = text;
        this.effect = effect;
    }

    GetName = () => this.name;
    GetAge = () => this.age;
    GetText = () => this.text;
    GetEffects = () => this.effect;
}

module.exports = Event;